/**
 * Whether a project belongs to an organization (enterprise). Community projects report
 * their org as 'public' or, for old projects, nothing at all.
 */
export default function isOrgProject(orgId) {
  return Boolean(orgId) && orgId !== 'public';
}
